export const missionCreateMessages = {
  "missions.create.objective": "What should the mission do?",
  "missions.create.objectivePlaceholder": "Describe the outcome you want. For a daily mission, these instructions apply to every run.",
  "missions.create.title": "Title",
  "missions.create.when": "When",
  "missions.create.once": "Once",
  "missions.create.daily": "Every day at",
  "missions.create.zone": "Time zone: {zone}",
  "missions.create.zoneChange": "Change",
  "missions.create.options": "Options",
  "missions.create.agents": "Agents and models",
  "missions.create.zoneOverride": "Time zone (IANA)",
  "missions.create.submit": "Create",
  "missions.create.brief.start": "Start from a brief",
  "missions.create.brief.none": "Blank mission",
  "missions.create.brief.more": "Saved brief actions",
  "missions.create.brief.saveAs": "Save as brief",
  "missions.create.brief.cancel": "Cancel saving the brief",
} as const
